(() => {
  const parseConfig = () => {
    const node = document.getElementById('OnwardTicketFlyConfig');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (error) { return {}; }
  };

  const config = parseConfig();
  const STORAGE_KEY = 'otf_booking_state';

  const getBookingState = () => {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}; } catch (error) { return {}; }
  };

  const setBookingState = (updates) => {
    const next = { ...getBookingState(), ...updates };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch (error) { /* Storage can be unavailable. */ }
    return next;
  };

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD' }).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  };

  const debounce = (callback, wait = 250) => {
    let timeout;
    return (...args) => {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => callback(...args), wait);
    };
  };

  const showToast = (message) => {
    const region = document.querySelector('[data-toast-region]');
    if (!region || !message) return;
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    region.appendChild(toast);
    window.setTimeout(() => toast.remove(), 5000);
  };

  window.OTF = { config, STORAGE_KEY, getBookingState, setBookingState, money, debounce, showToast };

  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const setupDialog = (dialog, openButtons, closeButtons, openClass, bodyClass) => {
    if (!dialog) return;
    let lastFocused;
    const open = () => {
      lastFocused = document.activeElement;
      dialog.hidden = false;
      requestAnimationFrame(() => dialog.classList.add(openClass));
      document.body.classList.add(bodyClass);
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      const first = dialog.querySelector(focusableSelector);
      if (first) first.focus();
    };
    const close = () => {
      dialog.classList.remove(openClass);
      document.body.classList.remove(bodyClass);
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      window.setTimeout(() => { dialog.hidden = true; }, 220);
      if (lastFocused) lastFocused.focus();
    };
    openButtons.forEach((button) => button.addEventListener('click', open));
    closeButtons.forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll(focusableSelector)].filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  };

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  setupDialog(
    mobileMenu,
    [...document.querySelectorAll('[data-mobile-menu-open]')],
    [...document.querySelectorAll('[data-mobile-menu-close]')],
    'is-open',
    'menu-open'
  );

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-results-search-toggle]').forEach((button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      if (!expanded) panel.querySelector('input')?.focus();
    });
  });

  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterOverlay = document.querySelector('[data-filter-overlay]');
  if (filterPanel) {
    const openFilters = () => {
      filterPanel.classList.add('is-open');
      if (filterOverlay) filterOverlay.hidden = false;
      document.body.classList.add('drawer-open');
      filterPanel.querySelector('input,select,button')?.focus();
    };
    const closeFilters = () => {
      filterPanel.classList.remove('is-open');
      if (filterOverlay) filterOverlay.hidden = true;
      document.body.classList.remove('drawer-open');
    };
    document.querySelectorAll('[data-filter-drawer-open]').forEach((button) => button.addEventListener('click', openFilters));
    document.querySelectorAll('[data-filter-drawer-close]').forEach((button) => button.addEventListener('click', closeFilters));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeFilters(); });
  }

  document.querySelectorAll('[data-summary-toggle]').forEach((button) => {
    const content = button.closest('[data-order-summary]')?.querySelector('[data-summary-content]');
    if (!content) return;
    if (window.matchMedia('(max-width: 899px)').matches) content.hidden = true;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      content.hidden = expanded;
    });
  });

  const mobileConversionBar = document.querySelector('[data-mobile-conversion-bar]');
  const searchDock = document.getElementById('search-your-flight');
  if (mobileConversionBar && searchDock && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      mobileConversionBar.classList.toggle('is-hidden', entries.some((entry) => entry.isIntersecting));
    }, { threshold: 0.08, rootMargin: '0px 0px -72px' });
    observer.observe(searchDock);
  }
})();
